/* Sezona 2026/2027 – odbrojavanje, reveal pri scrollu i svjetlo na karticama */
(() => {
  if (window.__blSeason) return;
  window.__blSeason = true;

  const pad = (n) => String(n).padStart(2, '0');

  function initCountdowns(root = document) {
    root.querySelectorAll('[data-bl-countdown]:not([data-bl-ready])').forEach((el) => {
      el.setAttribute('data-bl-ready', '');
      const target = new Date(el.getAttribute('data-bl-countdown')).getTime();
      if (Number.isNaN(target)) return;
      const parts = {
        d: el.querySelector('[data-unit="d"]'),
        h: el.querySelector('[data-unit="h"]'),
        m: el.querySelector('[data-unit="m"]'),
        s: el.querySelector('[data-unit="s"]'),
      };
      const tick = () => {
        let diff = Math.max(0, target - Date.now());
        const d = Math.floor(diff / 86400000);
        diff -= d * 86400000;
        const h = Math.floor(diff / 3600000);
        diff -= h * 3600000;
        const m = Math.floor(diff / 60000);
        diff -= m * 60000;
        const s = Math.floor(diff / 1000);
        if (parts.d) parts.d.textContent = d;
        if (parts.h) parts.h.textContent = pad(h);
        if (parts.m) parts.m.textContent = pad(m);
        if (parts.s) parts.s.textContent = pad(s);
      };
      tick();
      setInterval(tick, 1000);
    });
  }

  function initReveal(root = document) {
    const items = root.querySelectorAll('.bl [data-bl-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      items.forEach((el) => el.classList.add('is-in'));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    items.forEach((el) => io.observe(el));
  }

  function initGlow(root = document) {
    root.querySelectorAll('.bl-card:not([data-bl-glow])').forEach((card) => {
      card.setAttribute('data-bl-glow', '');
      card.addEventListener('pointermove', (e) => {
        const r = card.getBoundingClientRect();
        card.style.setProperty('--mx', `${e.clientX - r.left}px`);
        card.style.setProperty('--my', `${e.clientY - r.top}px`);
      });
    });
  }

  function init(root) {
    initCountdowns(root);
    initReveal(root);
    initGlow(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
